{
    "zcp": {
        "agent_code": "6915",
        "agent_seq": "95",
        "prod_type": "007",
        "pac_no": "041",
        "patn_plan": "ZCPTISCO_"
    },
    "zap_car": {
        "agent_code": "6915",
        "agent_seq": "95",
        "prod_type": "002",
        "pac_no": "106",
        "patn_plan": "ZAPTISCCAR_"
    },
    "zap_m": {
        "agent_code": "6915",
        "agent_seq": "95",
        "prod_type": "002",
        "pac_no": "102",
        "patn_plan": "ZAPTISCSOM_"
    },
    "mycare": {
        "agent_code": "6915",
        "agent_seq": "95",
        "prod_type": "073",
        "pac_no": "103",
        "patn_plan": "TSAVER2020_"
    }
}